import React from 'react';
import { useTranslation } from 'react-i18next';
import startCase from 'lodash-es/startCase';

import { Label } from '../../semantic';
import { PaymentFlow, ProductPaymentFlow } from '../../types/charging-session';

interface PaymentMethodProps {
  paymentFlow?: PaymentFlow;
  /**
   * productPaymentFlow is not populated in every scenario, for example when the session comes from elasticsearch
   * so productPaymentFlow is used as a fallback
   */
  productPaymentFlow?: ProductPaymentFlow;
}

export function PaymentMethod({
  paymentFlow,
  productPaymentFlow,
}: PaymentMethodProps) {
  const { t } = useTranslation();
  const paymentFlowLower = paymentFlow?.toLowerCase();
  const productPaymentFlowLower = productPaymentFlow?.toLowerCase();
  const flow = paymentFlowLower || productPaymentFlowLower;

  switch (flow) {
    case 'tap-to-pay':
      return (
        <Label content={t('payment.paymentMethod.tapToPay', 'Tap to pay')} />
      );
    case 'scan-to-pay':
      return (
        <Label content={t('payment.paymentMethod.scanToPay', 'Scan to pay')} />
      );
    case 'charge-card':
      return (
        <Label content={t('payment.paymentMethod.chargeCard', 'Charge Card')} />
      );
    default:
      return (
        <PaymentMethodLabelFallback
          paymentFlow={paymentFlow}
          productPaymentFlow={productPaymentFlow}
        />
      );
  }
}

function PaymentMethodLabelFallback({
  paymentFlow,
  productPaymentFlow,
}: PaymentMethodProps) {
  const { t } = useTranslation();
  const paymentFlowLower = paymentFlow?.toLowerCase();
  const productPaymentFlowLower = productPaymentFlow?.toLowerCase();

  if (paymentFlowLower) {
    return <Label content={startCase(paymentFlowLower)} />;
  }

  if (productPaymentFlowLower) {
    return <Label content={startCase(productPaymentFlowLower)} />;
  }

  return (
    <Label
      content={startCase(t('payment.paymentMethod.chargeCard', 'Charge Card'))}
    />
  );
}
